import React, { Component } from 'react'
import ProjectList from './ProjectList'

class Software extends Component {
  render(){
    return(
      <ProjectList />
    );
  }
}

export default Software



/** WEBPACK FOOTER **
 ** ./src/Software.js
 **/